import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { problems } from '../data/content';
import { CTAButton } from './CTAButton';
export function Problems() {
  return <section className="px-5 py-8" aria-labelledby="problemas-title" data-id="element-167" data-mp="32516mb0zc1b8">
      <h2 id="problemas-title" className="font-display text-[22px] leading-snug text-[#16302a]" data-id="element-168" data-mp="3237zkumgff2p">
        Si das clases de gimnasia postural, probablemente te haya pasado esto.
      </h2>

      <ul className="mt-5 space-y-3" data-id="element-169" data-mp="2t5xnx85q5nx9">
        {problems.map(p => <li key={p} className="flex gap-3 rounded-2xl border border-[#e6ded1] bg-white/80 p-4 backdrop-blur-sm" data-id="element-170" data-mp="2o504ks8zanu6">
            <AlertCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#b4553f]" aria-hidden="true" data-id="element-171" data-mp="2j89h3juugpyq" />
            <p className="text-[14px] leading-relaxed text-[#3d4f47]" data-id="element-172" data-mp="2f6o47yib8boj">{p}</p>
          </li>)}
      </ul>

      <div className="mt-6" data-id="element-173" data-mp="dd8f561vf4vo">
        <CTAButton label="Quiero dejar de improvisar" data-id="element-174" data-mp="dcyn7cx9mnnc" />
      </div>
    </section>;
}